<template>
  <div class="payment-skeleton">
    <div v-for="time in times" :key="time" class="skeleton-container" :class="{ full: times === 1 }">
      <div class="skeleton-header">
        <div class="skeleton-title" />
        <div class="skeleton-subtitle" />
      </div>
      <div class="skeleton-content">
        <div class="skeleton-card">
          <div class="skeleton-image" />
          <div class="skeleton-details">
            <div class="skeleton-line" />
            <div class="skeleton-line" />
            <div class="skeleton-line" />
          </div>
        </div>
        <div class="skeleton-price">
          <div class="skeleton-line" />
          <div class="skeleton-line" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    times: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-skeleton {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;

  .skeleton-container {
    width: 100%;
    padding: 24px;
    margin-bottom: 16px;
    background: #fff;
    border-radius: 8px;
    padding: 24px;

    &.full {
      width: 100%;
      height: 100%;
    }
  }

  .skeleton-header {
    margin-bottom: 24px;
  }

  .skeleton-title {
    height: 32px;
    background: #f0f0f0;
    width: 60%;
    margin-bottom: 16px;
    border-radius: 4px;
  }

  .skeleton-subtitle {
    height: 24px;
    background: #f0f0f0;
    width: 40%;
    border-radius: 4px;
  }

  .skeleton-content {
    display: flex;
    gap: 24px;
  }

  .skeleton-card {
    flex: 2;
    display: flex;
    gap: 16px;
  }

  .skeleton-image {
    width: 120px;
    height: 120px;
    background: #f0f0f0;
    border-radius: 8px;
  }

  .skeleton-details {
    flex: 1;
  }

  .skeleton-price {
    flex: 1;
  }

  .skeleton-line {
    height: 16px;
    background: #f0f0f0;
    border-radius: 4px;
    margin-bottom: 12px;

    &:nth-child(2) {
      width: 80%;
    }

    &:nth-child(3) {
      width: 60%;
    }
  }

  @keyframes shimmer {
    0% {
      background-position: -1000px 0;
    }

    100% {
      background-position: 1000px 0;
    }
  }

  .skeleton-title,
  .skeleton-subtitle,
  .skeleton-image,
  .skeleton-line {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 1000px 100%;
    animation: shimmer 2s infinite linear;
  }
}
</style>
